if (!customElements.get("brands-carousel")) {
  class BrandsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const swiperEl = this.querySelector(".swiper");
      if (!swiperEl) return;

      const options = {
        slidesPerView: 2,
        spaceBetween: 5,
        watchOverflow: true,
        centerInsufficientSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 10 },
          1024: { slidesPerView: 4, spaceBetween: 10 },
          1280: { slidesPerView: 5, spaceBetween: 10 },
        },
      };

      this.swiper = new Swiper(swiperEl, options);
      swiperEl.classList.add("is-initialized");
    }
  }

  customElements.define("brands-carousel", BrandsCarousel);
}
